// src/services/lavorazioniMeccanicoService.js
import { 
  collection, 
  doc, 
  getDocs, 
  addDoc, 
  serverTimestamp,
  query,
  orderBy
} from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Carica tutte le lavorazioni meccanico dal database
 */
export const getLavorazioniMeccanico = async () => {
  try {
    console.log('🔧 Caricamento lavorazioni meccanico...');
    
    const lavorazioniRef = collection(db, 'lavorazioniMeccanico');
    const q = query(lavorazioniRef, orderBy('nome', 'asc'));
    const snapshot = await getDocs(q);
    
    const lavorazioni = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    
    console.log(`✅ Caricate ${lavorazioni.length} lavorazioni meccanico`);
    return lavorazioni;
  } catch (error) {
    console.error('❌ Errore nel caricamento lavorazioni:', error);
    
    // Se la collezione non esiste, ritorna le lavorazioni predefinite
    return getLavorazioniPredefinite();
  }
};

/**
 * Crea una nuova lavorazione meccanico
 */
export const createLavorazioneMeccanico = async (nomeLavorazione) => {
  try {
    console.log('➕ Creazione nuova lavorazione:', nomeLavorazione);
    
    if (!nomeLavorazione || nomeLavorazione.trim() === '') {
      throw new Error('Nome lavorazione obbligatorio');
    }
    
    const lavorazioniRef = collection(db, 'lavorazioniMeccanico');
    const docRef = await addDoc(lavorazioniRef, {
      nome: nomeLavorazione.trim(),
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });
    
    console.log('✅ Lavorazione creata con ID:', docRef.id);
    return {
      id: docRef.id,
      nome: nomeLavorazione.trim()
    };
  } catch (error) {
    console.error('❌ Errore nella creazione lavorazione:', error);
    throw error;
  }
};

/**
 * Inizializza le lavorazioni predefinite nel database
 */
export const initializeLavorazioniPredefinite = async () => {
  try {
    console.log('🔄 Inizializzazione lavorazioni predefinite...');
    
    const lavorazioniPredefinite = getLavorazioniPredefinite();
    const lavorazioniRef = collection(db, 'lavorazioniMeccanico');
    
    // Verifica se esistono già lavorazioni
    const snapshot = await getDocs(lavorazioniRef);
    if (snapshot.size > 0) {
      console.log('ℹ️ Lavorazioni già presenti nel database');
      return;
    }
    
    // Aggiungi tutte le lavorazioni predefinite
    const promises = lavorazioniPredefinite.map(lav => 
      addDoc(lavorazioniRef, {
        nome: lav,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      })
    );
    
    await Promise.all(promises);
    console.log(`✅ Inizializzate ${lavorazioniPredefinite.length} lavorazioni predefinite`);
  } catch (error) {
    console.error('❌ Errore nell\'inizializzazione lavorazioni:', error);
    throw error;
  }
};

/**
 * Ritorna la lista delle lavorazioni predefinite (fallback)
 */
export const getLavorazioniPredefinite = () => {
  return [
    'Test compressione cilindri',
    'Sostituzione guarnizione testa',
    'Rettifica valvole',
    'Taratura iniettori',
    'Sostituzione turbocompressore',
    'Sostituzione volano bimassa',
    'Revisione cambio manuale',
    'Revisione cambio automatico',
    'Sostituzione differenziale',
    'Sostituzione servofreno',
    'Revisione pinze freno',
    'Spurgo ABS',
    'Sostituzione scatola guida',
    'Revisione ammortizzatori',
    'Regolazione geometria ruote',
    'Diagnosi ECU',
    'Sostituzione alternatore',
    'Sostituzione motorino avviamento',
    'Riparazione cablaggio',
    'Ricarica impianto A/C',
    'Sostituzione compressore',
    'Pulizia evaporatore',
    'Sostituzione radiatore A/C',
    'Cambio olio e filtro',
    'Sostituzione filtro aria',
    'Sostituzione candele',
    'Registrazione gioco valvole',
    'Sostituzione cinghia distribuzione',
    'Pulizia iniettori',
    'Sostituzione frizione',
    'Cambio olio cambio',
    'Sostituzione semiassi',
    'Sostituzione pastiglie',
    'Sostituzione dischi',
    'Spurgo freni',
    'Sostituzione ammortizzatori',
    'Sostituzione testine sterzo',
    'Controllo convergenza',
    'Controllo batteria',
    'Controllo alternatore',
    'Sostituzione fusibili',
    'Diagnosi elettronica',
    'Controllo livelli fluidi',
    'Sostituzione tergicristalli',
    'Lubrificazione cerniere e leveraggi',
    'Controllo scarico'
  ];
};